import React from "react";

import { NavLink } from "react-router-dom";

export default function Breadcrumb(props) {
  const { list } = props;

  return (
    <div className="flex flex-row gap-2">
      {list.map((item, index) => {
        return (
          <>
            {!item.is_active && (
              <NavLink to={item.link} className="breadcrumb-text">
                {item.title}
              </NavLink>
            )}

            {item.is_active && (
              <span className="breadcrumb-text-active">{item.title}</span>
            )}

            {index !== list.length - 1 && (
              <span className="breadcrumb-separator">/</span>
            )}
          </>
        );
      })}
    </div>
  );
}
